import { createStore } from 'vuex'

var URL = 'https://server-web.konaweselatankab.go.id/';
var URLS = 'https://dpppa.konaweselatankab.go.id/';

var UNIT = 'smuMn3Axxid8wvzTE';

export default createStore({
  state: {
    UNIT_KERJA : UNIT,
    url : {
      URL : URLS,
      URL_APP : URL,
      URL_SLIDER : URL + 'api/v1/publish_dpppa_slider/',
      URL_SAMBUTAN : URL + 'api/v1/publish_dpppa_sambutan/',
      URL_BERITA : URL + 'api/v1/web_publish_berita/',
      URL_FOTO : URL + 'api/v1/publish_dpppa_foto/',
      URL_VIDEO : URL + 'api/v1/publish_dpppa_video/',
      URL_LINK : URL + 'api/v1/web_publish_link_terkait/',
      URL_PROFIL : URL + 'api/v1/publish_dpppa_tentang/',
      URL_TUPOKSI : URL + 'api/v1/publish_dpppa_tupoksi/',
      URL_STRUKTUR : URL + 'api/v1/publish_dpppa_struktur_organisasi/',
      URL_VISI : URL + 'api/v1/publish_dpppa_visi_misi/',
      URL_BIDANG : URL + 'api/v1/publish_dpppa_bidang/',
      URL_PEJABAT : URL + 'api/v1/publish_dpppa_profil_pejabat/',
      URL_BERITA : URL + 'api/v1/web_publish_berita/',
      URL_PENGUMUMAN : URL + 'api/v1/publish_dpppa_pengumuman/',
      URL_DATA : URL + 'api/v1/publish_dpppa_data/',
      URL_PERATURAN : URL + 'api/v1/publish_dpppa_peraturan/',
      URL_DOKUMEN : URL + 'api/v1/publish_dpppa_dokumen/',
      URL_FOTO : URL + 'api/v1/publish_dpppa_foto/',
      URL_VIDEO : URL + 'api/v1/publish_dpppa_video/',
      URL_LAYANAN : URL + 'api/v1/publish_dpppa_layanan/',
    }
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  }
})
